module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS012B7DD06A-12-2-19.4b439705.pdf";